import PromotionColor from './PromotionColour.svg';
import PromotionDark from './PromotionDark.svg';
import PromotionLight from './PromotionLight.svg';
export const promotion = { color: PromotionColor, dark: PromotionDark, light: PromotionLight };
//# sourceMappingURL=index.js.map